module.exports = __webpack_public_path__ + "img/19.bb09aa1d.jpg";